import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import ISmdcShopDto from '@core/mappers/country/dtos/ISmdcShopDto';
import Shop from '@models/country/Shop';

export default class SmdcShopMapper extends AbstractMapper<ISmdcShopDto, Shop> {
    createTargetObject(dto: ISmdcShopDto, key: number): Shop {
        const shop = {} as Shop;
        const dtoSingle = (dto as any);

        shop.id = dtoSingle.shop_code.padStart(3, '0');
        shop.isActive = dtoSingle.online === '1' && dtoSingle.deleted === '0';

        return shop;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/country/SmdcShopMapper.ts